/* Nuvio — gift chooser (PDP + cart drawer). Loaded on the PDP and in the cart drawer. */
(function () {
  'use strict';
  if (window.__ngcLoaded) return;
  window.__ngcLoaded = true;

  var GIFT_PROP = '_bag_gift';
  var FIXED_PROP = '_bag_gift_fixed';
  var HANDLES_PROP = '_gift_handles';
  var MAX_PROP = '_gift_max';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function list(str) {
    return (str || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function hasProp(item, key) {
    return !!(item.properties && item.properties[key]);
  }

  /* Re-render the cart drawer + bubble without a page reload */
  function refreshDrawer(open) {
    var drawer = document.querySelector('cart-drawer');
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && typeof drawer.renderContents === 'function') {
          if (open) {
            drawer.renderContents({ sections: sections });
          } else {
            var inner = document.querySelector('#CartDrawer');
            var bubble = document.getElementById('cart-icon-bubble');
            var parse = function (html, sel) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              return doc.querySelector(sel);
            };
            if (inner && sections['cart-drawer']) {
              var n = parse(sections['cart-drawer'], '#CartDrawer');
              if (n) inner.innerHTML = n.innerHTML;
              /* Keep the drawer's empty state in sync (Dawn layout depends on .is-empty) */
              var d = parse(sections['cart-drawer'], 'cart-drawer');
              if (d) drawer.classList.toggle('is-empty', d.classList.contains('is-empty'));
            }
            if (bubble && sections['cart-icon-bubble']) {
              var b = parse(sections['cart-icon-bubble'], '.shopify-section');
              if (b) bubble.innerHTML = b.innerHTML;
            }
          }
        }
      })
      .catch(function () {});
  }

  /* ================= PDP ================= */
  function initPdp(box) {
    if (box.__ngc) return;
    box.__ngc = true;

    var max = parseInt(box.dataset.max, 10) || 2;
    var bagIds = list(box.dataset.bagIds);
    var area = box.querySelector('[data-ngc-area]');
    var giftBox = box.querySelector('[data-ngc-box]');
    var track = box.querySelector('[data-ngc-track]');
    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-ngc-card]'));
    var countEl = box.querySelector('[data-ngc-count]');
    var statusEl = box.querySelector('[data-ngc-status]');
    var moreBtn = box.querySelector('[data-ngc-more]');
    var formId = box.dataset.formId;
    var picked = [];

    function render() {
      cards.forEach(function (c) {
        var on = picked.indexOf(c.dataset.variantId) !== -1;
        c.classList.toggle('is-selected', on);
        var btn = c.querySelector('[data-ngc-select]');
        if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (countEl) {
        countEl.textContent = picked.length;
        countEl.parentElement.classList.toggle('is-full', picked.length >= max);
      }
      if (giftBox) giftBox.classList.toggle('is-full', picked.length >= max);
      if (statusEl) {
        if (!picked.length) {
          statusEl.textContent = statusEl.dataset.empty;
          statusEl.classList.remove('is-picked');
        } else {
          var names = cards
            .filter(function (c) { return picked.indexOf(c.dataset.variantId) !== -1; })
            .map(function (c) { return c.dataset.name; });
          statusEl.textContent = names.join(' + ') + ' selected';
          statusEl.classList.add('is-picked');
        }
      }
      var pickedNames = cards
        .filter(function (c) { return picked.indexOf(c.dataset.variantId) !== -1; })
        .map(function (c) { return c.dataset.name; });
      document.querySelectorAll('[data-ngc-gift-names]').forEach(function (el) {
        el.textContent = pickedNames.length ? pickedNames.join(' + ') : el.dataset.none;
      });
    }

    cards.forEach(function (c) {
      var btn = c.querySelector('[data-ngc-select]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var id = c.dataset.variantId;
        var i = picked.indexOf(id);
        if (i !== -1) {
          picked.splice(i, 1);
        } else if (picked.length < max) {
          picked.push(id);
        } else {
          // Full: replace the oldest pick so the tap always does something
          picked.shift();
          picked.push(id);
        }
        render();
      });
    });

    /* "More gifts" arrows: hidden when all cards fit (scrolling is handled globally below) */
    function updateMore() {
      if (!moreBtn || !track) return;
      moreBtn.hidden = track.scrollWidth <= track.clientWidth + 4;
      updateArrows(track);
    }
    if (moreBtn && track) {
      window.addEventListener('resize', updateMore);
      updateMore();
    }

    /* Show the gift area only for the gift variant (e.g. Bag) */
    function form() { return document.getElementById(formId); }
    function currentVariantId() {
      var f = form();
      var input = f && f.querySelector('input[name="id"]');
      return input ? String(input.value) : '';
    }
    function syncVariant() {
      if (!area) return;
      var isBag = bagIds.indexOf(currentVariantId()) !== -1;
      area.hidden = !isBag;
      if (isBag) { updateMore(); requestAnimationFrame(function () { fitNames(box); }); }
      // What's Included popup follows the selected variant (Bag / Mat)
      // (the links can live in their own block, so update every What's Included popup on the page)
      document.querySelectorAll('[id^="PopupModal-ngc-included-"]').forEach(function (incModal) {
        if (incModal.querySelector('[data-ngc-inc-tab]')) showIncluded(incModal, isBag ? 1 : 2);
      });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(syncVariant, 0);
    });
    document.addEventListener('variant:changed', function () { setTimeout(syncVariant, 50); });
    syncVariant();

    /* FAQ popup: turn bold questions / headings into accordions */
    box.querySelectorAll('[data-ngc-faq]').forEach(buildFaq);
    // Modals are moved to <body> by the theme, so also look there
    document.querySelectorAll('.ngc-modal [data-ngc-faq]').forEach(buildFaq);

    /* Expose for the submit interceptor */
    box.__ngcState = {
      bagIds: bagIds,
      max: max,
      handles: box.dataset.giftHandles || '',
      extraIds: list(box.dataset.extraIds),
      cartTitle: box.dataset.cartTitle || '',
      strip: box.dataset.strip || '',
      picked: function () { return picked.slice(); },
      reset: function () { picked = []; render(); },
    };
    render();
  }

  function buildFaq(body) {
    if (body.dataset.ngcBuilt) return;
    body.dataset.ngcBuilt = '1';
    var nodes = Array.prototype.slice.call(body.children);
    var isQ = function (el) {
      if (/^H[1-6]$/.test(el.tagName)) return true;
      if (el.tagName === 'P' && el.querySelector('strong,b')) {
        var t = el.textContent.trim();
        return t.slice(-1) === '?' && t.length < 220;
      }
      return false;
    };
    var groups = [];
    var cur = null;
    nodes.forEach(function (n) {
      if (isQ(n)) {
        cur = { q: n, a: [] };
        groups.push(cur);
      } else if (cur) {
        cur.a.push(n);
      }
    });
    if (!groups.length) return;
    groups.forEach(function (g) {
      var d = document.createElement('details');
      d.className = 'ngc-faq-item';
      var s = document.createElement('summary');
      s.innerHTML = '<span>' + g.q.textContent.trim() + '</span>';
      var a = document.createElement('div');
      a.className = 'ngc-faq-a';
      g.a.forEach(function (n) { a.appendChild(n); });
      d.appendChild(s);
      d.appendChild(a);
      g.q.replaceWith(d);
    });
  }

  /* Intercept Add to cart for the gift variant: add gifts first, then let the theme add the product */
  document.addEventListener(
    'submit',
    function (e) {
      var formEl = e.target;
      if (!formEl || formEl.tagName !== 'FORM') return;
      var idInput = formEl.querySelector('input[name="id"]');
      if (!idInput) return;

      var box = document.querySelector('[data-ngc]');
      var st = box && box.__ngcState;
      if (!st) return;

      var vid = String(idInput.value);
      var isBag = st.bagIds.indexOf(vid) !== -1;

      // Remove stale gift inputs (e.g. Bag was chosen earlier, Mat now)
      formEl.querySelectorAll('[data-ngc-input]').forEach(function (n) { n.remove(); });
      if (!isBag) return;

      if (formEl.dataset.ngcPass === '1') {
        delete formEl.dataset.ngcPass;
        addInputs(formEl, st);
        return; // let the theme handler run
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      holdCleanup(8000); // gifts first, product second: don't clean up in between

      saveConfig(st, vid)
        .then(getCart)
        .then(function (cart) {
          var items = cart.items || [];
          var inCart = {};
          var giftCount = 0;
          items.forEach(function (it) {
            if (hasProp(it, GIFT_PROP)) { giftCount += it.quantity; inCart[String(it.variant_id)] = true; }
            if (hasProp(it, FIXED_PROP)) { inCart[String(it.variant_id)] = true; }
          });
          var add = [];
          var room = st.max - giftCount;
          st.picked().forEach(function (id) {
            if (room > 0 && !inCart[id]) {
              add.push({ id: Number(id), quantity: 1, properties: { _bag_gift: '1' } });
              room--;
            }
          });
          st.extraIds.forEach(function (id) {
            if (!inCart[id]) add.push({ id: Number(id), quantity: 1, properties: { _bag_gift_fixed: '1' } });
          });
          if (!add.length) return null;
          return postJSON('cart/add.js', { items: add }).then(function (res) {
            if (res && res.status) {
              console.warn('[Nuvio gifts] Adding gifts together failed, trying one by one:', res.description || res.message);
              return add.reduce(function (chain, item) {
                return chain.then(function () {
                  return postJSON('cart/add.js', { items: [item] }).then(function (r) {
                    if (r && r.status) console.warn('[Nuvio gifts] Gift could not be added (variant ' + item.id + '):', r.description || r.message);
                  });
                });
              }, Promise.resolve());
            }
            return res;
          });
        })
        .catch(function (err) { console.warn('[Nuvio gifts]', err); })
        .then(function () {
          formEl.dataset.ngcPass = '1';
          if (typeof formEl.requestSubmit === 'function') {
            formEl.requestSubmit();
          } else {
            formEl.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }
        });
    },
    true
  );

  var holdUntil = 0;
  function holdCleanup(ms) { holdUntil = Date.now() + ms; }

  /* Store the gift setup on the cart itself, so the drawer still knows which line is the
     gift product even if an app or the theme drops the line properties. */
  function saveConfig(st, vid) {
    return getCart()
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        var bags = attrs._ngc_bags || ',';
        st.bagIds.forEach(function (id) {
          if (bags.indexOf(',' + id + ',') === -1) bags += id + ',';
        });
        var want = {
          _ngc_bags: bags,
          _ngc_handles: st.handles,
          _ngc_max: String(st.max),
          _ngc_title: st.cartTitle,
          _ngc_strip: st.strip,
        };
        var same = Object.keys(want).every(function (k) { return attrs[k] === want[k]; });
        return same ? null : postJSON('cart/update.js', { attributes: want });
      })
      .catch(function (err) { console.warn('[Nuvio gifts] Could not save gift setup:', err); });
  }

  function addInputs(formEl, st) {
    var props = {};
    props[HANDLES_PROP] = st.handles;
    props[MAX_PROP] = String(st.max);
    props._gift_title = st.cartTitle;
    props._gift_strip = st.strip;
    Object.keys(props).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + k + ']';
      i.value = props[k];
      i.setAttribute('data-ngc-input', '');
      formEl.appendChild(i);
    });
  }

  /* ================= Cart drawer ================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ngc-cart-add]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-ngc-card]');
    if (card) card.classList.add('is-busy');
    postJSON('cart/add.js', {
      items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _bag_gift: '1' } }],
    })
      .then(function () { return refreshDrawer(false); })
      .then(cleanup);
  });

  /* Gift slider arrows (product page + cart): back / forward one card.
     Delegated, because the drawer HTML is replaced after every cart change. */
  function trackFor(btn) {
    var root = btn.closest('.ngc-box, .ngc-cart, .ngc');
    return root ? root.querySelector('.ngc-track') : null;
  }
  function arrowsFor(track) {
    var root = track.closest('.ngc-box, .ngc-cart, .ngc');
    return root ? root.querySelectorAll('[data-ngc-scroll]') : [];
  }
  function updateArrows(track) {
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    Array.prototype.forEach.call(arrowsFor(track), function (b) {
      var dir = Number(b.dataset.ngcScroll);
      b.disabled = dir < 0 ? track.scrollLeft <= 4 : track.scrollLeft >= max - 4;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ngc-scroll]');
    if (!btn) return;
    e.preventDefault();
    var track = trackFor(btn);
    if (!track) return;
    var card = track.querySelector('[data-ngc-card]');
    var step = card ? card.getBoundingClientRect().width + 8 : track.clientWidth / 2;
    track.scrollBy({ left: Number(btn.dataset.ngcScroll) * step, behavior: 'smooth' });
  });
  // Element scroll events don't bubble, so listen in the capture phase
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('ngc-track')) updateArrows(t);
  }, true);

  /* What's Included popup: Bag / Mat switch */
  function showIncluded(modal, n) {
    if (!modal) return;
    Array.prototype.forEach.call(modal.querySelectorAll('[data-ngc-inc-tab]'), function (t) {
      var on = t.dataset.ngcIncTab === String(n);
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(modal.querySelectorAll('[data-ngc-inc-panel]'), function (p) {
      p.hidden = p.dataset.ngcIncPanel !== String(n);
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ngc-inc-tab]');
    if (!tab) return;
    e.preventDefault();
    showIncluded(tab.closest('modal-dialog, .ngc-modal'), tab.dataset.ngcIncTab);
  });

  /* Keep gifts consistent: no gifts without the product, never more than max, qty 1 each */
  var cleaning = false;
  function cleanup() {
    if (cleaning) return Promise.resolve();
    var wait = holdUntil - Date.now();
    if (wait > 0) {
      scheduleCleanup(wait + 50);
      return Promise.resolve();
    }
    cleaning = true;
    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var attrs = cart.attributes || {};
        var bagAttr = attrs._ngc_bags || '';
        var bagLines = items.filter(function (it) {
          return hasProp(it, HANDLES_PROP) || bagAttr.indexOf(',' + it.variant_id + ',') !== -1;
        });
        var max = 0;
        bagLines.forEach(function (it) {
          var m = parseInt((it.properties && it.properties[MAX_PROP]) || attrs._ngc_max, 10) || 2;
          if (m > max) max = m;
        });
        var updates = {};
        var used = 0;
        items.forEach(function (it) {
          if (hasProp(it, GIFT_PROP)) {
            var allowed = Math.max(0, Math.min(1, max - used));
            if (it.quantity !== allowed) updates[it.key] = allowed;
            used += allowed;
          } else if (hasProp(it, FIXED_PROP)) {
            var want = bagLines.length ? 1 : 0;
            if (it.quantity !== want) updates[it.key] = want;
          }
        });
        if (!Object.keys(updates).length) return null;
        return postJSON('cart/update.js', { updates: updates }).then(function () { return refreshDrawer(false); });
      })
      .catch(function () {})
      .then(function () { cleaning = false; });
  }

  /* Run cleanup after any cart change made by the theme or other scripts (remove, quantity, upsell add…).
     Watching fetch instead of the DOM avoids reacting to the drawer's countdown timer. */
  var timer = null;
  function scheduleCleanup(delay) {
    clearTimeout(timer);
    timer = setTimeout(cleanup, delay || 300);
  }
  if (window.fetch && !window.fetch.__ngc) {
    var origFetch = window.fetch;
    var wrapped = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        var themeAdd = /\/cart\/add(\?|$)/.test(url); // the theme's Add to cart (ours use add.js)
        p.then(function () {
          if (themeAdd) holdUntil = 0;
          if (!cleaning) scheduleCleanup(themeAdd ? 600 : 300);
        }, function () { if (themeAdd) holdUntil = 0; });
      }
      return p;
    };
    wrapped.__ngc = true;
    window.fetch = wrapped;
  }

  /* Gift names always fit on 2 lines: long names (e.g. Shoulder/Chest Wrap) shrink a little */
  function fitNames(scope) {
    var els = (scope || document).querySelectorAll('.ngc-card__name');
    Array.prototype.forEach.call(els, function (el) {
      el.style.fontSize = '';
      if (!el.offsetHeight) return; // hidden (e.g. Mat selected) - fitted again when shown
      var cs = getComputedStyle(el);
      var fs = parseFloat(cs.fontSize);
      var guard = 0;
      while (guard < 10 && fs > 10) {
        var lh = parseFloat(getComputedStyle(el).lineHeight) || fs * 1.2;
        if (el.scrollHeight <= lh * 2 + 1 && el.scrollWidth <= el.clientWidth + 1) break;
        fs -= 0.5;
        el.style.fontSize = fs + 'px';
        guard++;
      }
    });
  }
  window.NuvioFitGiftNames = fitNames;

  /* Standalone Info links block (no gift box on the page): What's Included follows Bag / Mat */
  function initLinks(box) {
    if (box.__ngcl) return;
    box.__ngcl = true;
    if (document.querySelector('[data-ngc]')) return; // the gift box already keeps the popup in sync
    var bagIds = list(box.dataset.bagIds);
    var sync = function () {
      var f = document.getElementById(box.dataset.formId);
      var input = f && f.querySelector('input[name="id"]');
      if (!input) return;
      var isBag = bagIds.indexOf(String(input.value)) !== -1;
      document.querySelectorAll('[id^="PopupModal-ngc-included-"]').forEach(function (m) {
        if (m.querySelector('[data-ngc-inc-tab]')) showIncluded(m, isBag ? 1 : 2);
      });
    };
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(sync, 0);
    });
    document.addEventListener('variant:changed', function () { setTimeout(sync, 50); });
  }

  function init() {
    document.querySelectorAll('[data-ngc]').forEach(initPdp);
    document.querySelectorAll('[data-ngc-links]').forEach(initLinks);
    document.querySelectorAll('[data-ngc-faq]').forEach(buildFaq);
    cleanup();
    fitNames();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitNames(); });
    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fitNames(); }, 200); }, { passive: true });
    // Cart drawer content is replaced after every change: fit its gift names again
    var cd = document.getElementById('CartDrawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { requestAnimationFrame(function () { fitNames(cd); }); }).observe(cd, { childList: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();